/**
 * Normalized API error thrown by the `edenData` seam. Kept in its own
 * dependency-free module so importing it never drags in `@/lib/api` (and
 * therefore Firebase) — the `edenData` unit tests rely on that isolation.
 *
 * It exposes a structured `error: { code, message, data? }` property so the
 * existing error pipeline (`getApiError`, `extractErrorData`, `mapApiError`,
 * `useNotifyApiError`) reads it exactly like a generated-client / direct
 * envelope error — no pipeline changes needed when call sites move to Eden.
 */
export class ApiCallError extends Error {
  readonly status: number;
  readonly code: string;
  readonly data?: Record<string, unknown>;
  readonly error: {
    code: string;
    message: string;
    data?: Record<string, unknown>;
  };
  constructor(status: number, code: string, message: string, data?: Record<string, unknown>) {
    super(message);
    this.name = "ApiCallError";
    this.status = status;
    this.code = code;
    this.data = data;
    this.error = data !== undefined ? { code, message, data } : { code, message };
  }
}
